// Le backend enregistre certains messages automatiques (chat et notifications) en anglais,
// en dur. On les reconnaît ici pour les afficher dans la langue de l'utilisateur. Le texte
// saisi par une personne n'est jamais passé à t() : seule une correspondance exacte (ou un
// préfixe connu) avec ces messages système déclenche la traduction.
const SYSTEM_MESSAGES = [
  { match: (m) => m === 'Your claim has been treated', key: 'systemMessage.claimTreated' },
  { match: (m) => m.startsWith('A new Message has been sent to you'), key: 'systemMessage.newMessage' },
  { match: (m) => m.startsWith('A new files has been added to'), key: 'systemMessage.newFiles' }
];

export const translateSystemMessage = (message, t) => {
  if (typeof message !== 'string') return message;
  const trimmed = message.trim();
  const known = SYSTEM_MESSAGES.find(({ match }) => match(trimmed));
  return known ? t(known.key) : message;
};

// Rôle d'un membre du personnel (account_type du backend) -> libellé traduit.
export const translateAccountType = (accountType, t) =>
  accountType ? t(`accountType.${accountType}`, { defaultValue: accountType }) : accountType;

export default translateSystemMessage;
